var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FundLetters'),_c('FundReports'),_c('AddDocumentModal',{on:{"save-document":_vm.handleSaveDocument}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }